<section
  data-test="tabs"
  class="flex items-center justify-between gap-3"
  [class.justify-between]="tabs().length > 2"
  [class.justify-center]="tabs().length <= 2">
  @for (tab of tabs(); track $index) {
  <button
    data-test="tab"
    (click)="selectTab(tab)"
    [clicks]="clicksPrefix() + tab.value"
    class="preset-title-6 md:preset-title-3 shadow-button-inset grow cursor-pointer rounded-3xl px-3 py-1"
    [class.text-primary-900]="activeTab() === tab.value"
    [class.text-white]="activeTab() !== tab.value"
    [class.bg-accent-900]="activeTab() === tab.value"
    [class.bg-primary-500]="activeTab() !== tab.value">
    {{ tab.name }}
  </button>
  }
</section>
